import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';
import localisedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(localisedFormat);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isToday);
dayjs.extend(isYesterday);

export const format = (
  date: Date | string | undefined,
  format = 'YYYY-MM-DD'
): string => {
  if (!date) return '';
  return dayjs(date).format(format);
};

export const formatTimestamp = (date: Date | string): string => {
  return dayjs(date).format('MMM DD, YYYY HH:mm');
};

export const formatAbbreviatedTimestamp = (date: string): string =>
  dayjs(date).format('HH:mm');
